import { render, staticRenderFns } from "./OverpackBadgeStatus.vue?vue&type=template&id=170a98db&scoped=true&"
import script from "./OverpackBadgeStatus.vue?vue&type=script&lang=js&"
export * from "./OverpackBadgeStatus.vue?vue&type=script&lang=js&"
import style0 from "./OverpackBadgeStatus.vue?vue&type=style&index=0&id=170a98db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a98db",
  null
  
)

export default component.exports